import { ArrowLeftRight, BellRing, Megaphone, ShieldCheck, Wrench } from 'lucide-react';

const categoryIcons = {
  security: ShieldCheck,
  transactional: ArrowLeftRight,
  marketing: Megaphone,
  system: Wrench,
};

export function NotificationCategoryIcon({
  category,
  unread,
  compact = false,
}: {
  category: string;
  unread: boolean;
  compact?: boolean;
}) {
  const normalizedCategory = category.toLowerCase() as keyof typeof categoryIcons;
  const Icon = categoryIcons[normalizedCategory] ?? BellRing;

  return (
    <span
      title={category}
      className={`${compact ? 'h-[2.6rem] w-[2.6rem]' : 'h-[3.6rem] w-[3.6rem]'} flex shrink-0 items-center justify-center ${unread ? 'text-[#16876A] dark:text-[#57E8BA]' : 'text-second'}`}
      aria-hidden="true"
    >
      <Icon className={compact ? 'h-[1.6rem] w-[1.6rem]' : 'h-[2.1rem] w-[2.1rem]'} strokeWidth={1.7} />
    </span>
  );
}
